export default __webpack_public_path__ + "static/recmixreel-6a3d1093622c8a3958df201a3684f503.mp3";